module.exports = "<template class=\"memolanguage-SvgIcon\">\n  <svgicon class=\"TEST\" icon.bind=\"icon\"></svgicon>\n</template>\n";